// @flow weak

/* eslint no-console:0 */
import React, {
  PureComponent
}                     from 'react';
import PropTypes      from 'prop-types';
import {
  AnimatedView,
  Breadcrumb,
}    from '../../components';

class General extends PureComponent {
  static propTypes= {
    actions: PropTypes.shape({
      enterGeneral: PropTypes.func,
      leaveGeneral: PropTypes.func
    })
  };

  componentWillMount() {
    this.props.actions.enterGeneral();
  }

  componentWillUnmount() {
    this.props.actions.leaveGeneral();
  }

  render() {
    return(
      <AnimatedView>
       
      </AnimatedView>
    );
  }
}

export default General;



// WEBPACK FOOTER //
// ./src/app/views/general/General.js